import {IApiBaseUrlFactory} from './iApiBaseUrlFactory';

export function apiBaseUrlFactory($injector): IApiBaseUrlFactory {
    let apiBaseUrl: string;

    const factory: IApiBaseUrlFactory = {
        set: set,
        get: get
    };
    return factory;

    function set(host: string) {
        if (host.indexOf('localhost') > -1) {
            apiBaseUrl = 'https://localhost:7293';
        } else {
            apiBaseUrl = $injector.get('MetatagService').get('apiUrl');
        }
    }

    function get() {
        if (!apiBaseUrl)
            throw 'ApiBaseUrl not set';

        return apiBaseUrl;
    }
}


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/core/apiBaseUrl.factory.ts
 **/